import {
  GET_COSMETIC_COMMISSIONS
} from '../types';

const initialState = {
  cosmeticCommissions: [],
};

export default function CosmeticCommissions(state = initialState, action) {
  switch (action.type) {
    case GET_COSMETIC_COMMISSIONS:
      return {
        ...state,
        cosmeticCommissions: action.payload,
      };
    default:
      return state;
  }
}
